/**
 * Auth domain models - Core authentication concepts
 */

export type LoginStep = 'credentials' | 'choose2fa' | 'verify2fa' | 'authenticated';

export type RegistrationStep =
  | 'otp'        // UsernameForm
  | 'password'   // PasswordForm
  | 'emailCode'  // EmailConfirmation
  | 'phoneCode'  // PhoneConfirmation
  | 'complete';  // RegistrationSuccess

export const REGISTRATION_STEPS: RegistrationStep[] = [
  'otp',
  'emailCode',
  'phoneCode',
  'password',
  'complete'
];

export function getNextStep(current: RegistrationStep): RegistrationStep | null {
  const idx = REGISTRATION_STEPS.indexOf(current);
  return idx < REGISTRATION_STEPS.length - 1 ? REGISTRATION_STEPS[idx + 1] : null;
}

export function getPrevStep(current: RegistrationStep): RegistrationStep | null {
  const idx = REGISTRATION_STEPS.indexOf(current);
  return idx > 0 ? REGISTRATION_STEPS[idx - 1] : null;
}

export type TwoFactorMethod = 'sms' | 'email';

export interface RegistrationData {
  username?: string;
  otp?: string;
  password?: string;
  confirmPassword?: string;
  emailCode?: string;
  phoneCode?: string;
}

export interface RegistrationState {
  step: RegistrationStep;
  data: RegistrationData;
  loading: boolean;
  error?: string;
}
